import styled from '@emotion/styled';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { BabIcon } from 'src/domains/layouts/shared/assets/icons/BabIcon';

import { InPlayIcon } from 'src/domains/layouts/shared/assets/icons/InPlayIcon';

import { withConfig } from 'src/withConfig';



interface EventStatusPropsType {

    variant: DefaultComponentVariantType | null;

}



export const EventStatus = withConfig(theme => styled('span', { label: 'EventStatus' })<EventStatusPropsType>`

    color: ${theme.star.eventRow.txtColorQuaternary};

    font-size: ${theme.star.eventRow.typography.fontSizeSecondary};

    line-height: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.eventRow.typography.lineHeightTertiary : theme.star.eventRow.typography.lineHeightSecondary};

`);



export const EventRowTimeInfo = withConfig(theme => styled('div', { label: 'EventRowTimeInfo' })`

    color: ${theme.star.eventRow.txtColorSecondary};

`);



export const EventRowInPlayInfo = withConfig(theme => styled('div', { label: 'EventRowInPlayInfo' })`

    align-items: center;

    color: ${theme.star.eventRow6PackColors.txtColorSecondary};

    display: flex;

    font-size: ${theme.star.eventRow.typography.fontSizeSecondary};

    gap: 4px;

    line-height: ${theme.star.eventRow.typography.lineHeightSecondary};

`);



export const EventInPlayIcon = styled(InPlayIcon, { label: 'EventInPlayIcon' })`

    fill: currentcolor;

    width: 12px;

`;



export const BabIconWrapper = withConfig(theme => styled(BabIcon, { label: 'BabIconWrapper' })`

    fill: ${theme.star.eventRow.bgColorQuinary};

    width: 14px;

    margin: 0 4px;

`);

